import { Button, Flex, Text } from '@applyboard/crystal-ui'
import { IntakeSearchResource } from '@backend/agents-ui-api/resources/intake-search/types'
import { StudentApplication } from '../../../../components/Application/types'

type ProgramCardButtonProps = {
  loading?: boolean
  disabled?: boolean
  onClick: () => void
  intakeSearch: IntakeSearchResource
  currentApplication?: StudentApplication['attributes']
  isDesktop?: boolean
  primarySelectedProgramId?: string
  alternateProgramSelected?: string
}

export function ProgramCardButton(props: ProgramCardButtonProps) {
  if (props.intakeSearch.attributes.intake.status === 'OPEN') {
    if (props.primarySelectedProgramId === props.intakeSearch.id) {
      return (
        <NotClickableLabel
          isDesktop={props.isDesktop}
          label="Selected Primary"
        />
      )
    }

    if (props.alternateProgramSelected === props.intakeSearch.id) {
      return (
        <NotClickableLabel
          isDesktop={props.isDesktop}
          label="Selected Alternate"
        />
      )
    }

    if (props.currentApplication && props.currentApplication.programSelected?.programIntakeId === props.intakeSearch.id) {
      return (
        <NotClickableLabel
          isDesktop={props.isDesktop}
          label="Currently Selected"
        />
      )
    }

    return (
      <Button
        intent="primary"
        emphasis={props.isDesktop ? 'highlighted' : 'outlined'}
        width={props.isDesktop ? 'hug' : 'fill'}
        onClick={props.onClick}
        disabled={props.disabled}
        loading={props.loading}
      >
        {props.primarySelectedProgramId ? props.currentApplication ? 'Update alternate' : 'Add alternate' : 'Apply'}
      </Button>
    )
  }

  return (
    <Flex pb={{ xs: 5, md: 0 }} justify={{ xs: 'center', md: 'start' }}>
      <Text variant="labelL" contrast="low">
        Not Available
      </Text>
    </Flex>
  )
}

type NotClickableLabelProps = Readonly<{
  isDesktop?: ProgramCardButtonProps['isDesktop']
  label: string
}>

function NotClickableLabel(props: NotClickableLabelProps) {
  return (
    <Flex
      pb={!props.isDesktop ? 5 : undefined}
      justify={!props.isDesktop ? 'center' : undefined}
    >
      <Text variant="labelL" contrast="low">
        {props.label}
      </Text>
    </Flex>
  )
}
